"use client";

/* eslint-disable react/destructuring-assignment */
import { DownloadIcon, FileIcon } from "icons";
import { useState } from "react";
import { Button as AriaButton } from "react-aria-components";
import { Modal, Text, ImageWrapper } from "ui-components";

import {
  AssetEntity,
  MessageAttachmentEntity,
} from "@/src/hooks/api/generated";
import { useDownload } from "@/src/hooks/useDownload";

import { contentClass, messageClass } from "./Message";

export interface IMessageAttachmentsProps {
  attachment: MessageAttachmentEntity;
  isOwnMessage: boolean;
}

function RenderAttachments(
  attachment: AssetEntity,
  isOwnMessage: boolean
): JSX.Element {
  const [isShowModal, setIsShowModal] = useState(false);
  if (!attachment.original_name) {
    return <div />;
  }

  if (
    attachment.fileType === "image/gif" ||
    attachment.fileType === "image/jpeg" ||
    attachment.fileType === "image/png" ||
    attachment.fileType === "image/svg+xml" ||
    attachment.fileType === "image/webp"
  ) {
    return (
      <div className="relative w-80 h-[180px]">
        <Modal
          isBackgroundBlur
          isOpen={isShowModal}
          animatedModalClassName="min-w-[760px] h-[550px] flex flex-1 items-center justify-center"
          onOpenChange={(value) => setIsShowModal(value)}
          isDismissable
          background="transparent"
        >
          <ImageWrapper
            src={attachment.public_id}
            alt={attachment.name}
            fill
            className="rounded-2xl object-contain max-h-[450px] mt-20"
            isCLDImage
          />
        </Modal>
        <button onClick={() => setIsShowModal(true)}>
          <ImageWrapper
            src={attachment.public_id}
            alt={attachment.name}
            fill
            className="rounded-2xl object-cover"
            isCLDImage
          />
        </button>
      </div>
    );
  }

  if (
    attachment.fileType === "video/mp4" ||
    attachment.fileType === "video/quicktime"
  ) {
    return (
      // eslint-disable-next-line jsx-a11y/media-has-caption
      <video
        controls
        key={attachment.name}
        style={{ width: "320px", borderRadius: 20 }}
      >
        <source src={attachment.name} type={attachment.fileType} />
      </video>
    );
  }

  if (attachment.fileType === "application/pdf") {
    return (
      <div className={messageClass({ isOwnMessage })}>
        <Modal
          isOpen={isShowModal}
          animatedModalClassName="min-w-[80%] h-[80%] flex flex-1 items-center justify-center"
          onOpenChange={(value) => setIsShowModal(value)}
          isDismissable
        >
          <div className="flex flex-1 w-full flex-col items-center justify-center">
            <object
              data={attachment.name}
              type="application/pdf"
              width="100%"
              height="100%"
            >
              <p>
                <a href={attachment.name}>Download pdf</a>
              </p>
            </object>
          </div>
        </Modal>
        <button
          onClick={() => setIsShowModal(true)}
          className={contentClass({ isOwnMessage, className: "w-full" })}
        >
          <Text className="underline-offset-2 underline">
            {attachment.original_name}
          </Text>
        </button>
      </div>
    );
  }

  return (
    <div className="flex justify-center flex-col gap-2 items-center w-80 h-40 border rounded-2xl">
      <FileIcon className="w-5 h-5" />

      <Text>{attachment.original_name}</Text>
    </div>
  );
}
export function MessageAttachments(
  file: IMessageAttachmentsProps
): JSX.Element {
  const downloadFile = useDownload();

  return (
    <div className="flex flex-1 flex-col w-80">
      <div className="relative w-80 h-80 flex flex-col flex-1 items-end justify-center ">
        {RenderAttachments(file.attachment.asset, file.isOwnMessage)}
      </div>
      <AriaButton
        className="flex gap-1 items-end justify-end mt-1 outline-none "
        onPress={() =>
          downloadFile({
            fileUrl: file.attachment.asset.name,
            originalName: file.attachment.asset.original_name,
          })
        }
      >
        <DownloadIcon className="w-4 h-4" />
        <Text className="underline underline-offset-2">Download</Text>
      </AriaButton>
    </div>
  );
}
